// extracted by mini-css-extract-plugin
export var active = "header-menu-module--active--aco+S";
export var link = "header-menu-module--link--7AK6a";
export var root = "header-menu-module--root--vXV1P";
export var user = "header-menu-module--user--P7lah";